// ============================================================================
// PublicationComposer — bande d'ouverture de l'editeur de publication
// ============================================================================
// E1a livrait la bande INERTE, E1b la depliait en formulaire dans la carte.
// Depuis feat-gest-la-publication-se-voit-sur-le-telephone, la bande OUVRE
// l'editeur en grand (PublicationEditor : etapes + apercu telephone), rendu par
// AccueilView a la place du fil ; la publication optimiste y a demenage.

import { GsAvatar, GS_COMPONENTS } from '@gs/ui';
import type { TFunction } from 'i18next';
import type { OptimisticAuthor } from '../../hooks/useAccueilMutations';

export function PublicationComposer({
  author,
  firstName,
  t,
  onOpen,
}: {
  author: OptimisticAuthor;
  firstName: string;
  t: TFunction;
  /** Ouvre l'editeur de publication. */
  onOpen: () => void;
}) {
  // Affordance app-locale (faux « placeholder » cliquable) — acceptable BL-18/B-4 ;
  // ne pas forcer un token input (ce n'est pas un champ).
  return (
    <div className="mb-4 flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-xs dark:border-slate-700 dark:bg-slate-800">
      <GsAvatar name={author.name ?? author.email} size="sm" />
      <button
        type="button"
        onClick={onOpen}
        className="min-w-0 flex-1 truncate text-left text-body text-slate-400 transition-colors hover:text-slate-500 dark:text-slate-500 dark:hover:text-slate-400"
      >
        {t('gest:accueil.composer.placeholder', { name: firstName })}
      </button>
      <button type="button" onClick={onOpen} className={GS_COMPONENTS.btnAction}>
        {t('gest:accueil.composer.publish')}
      </button>
    </div>
  );
}
